import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridNoRecords,
  GridColumn,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { useClosedForCommentTableController } from "./ClosedForCommentTableController";
import { CircularProgress } from "@material-ui/core";
import { DraftPreviewModal } from "../../../../stateOffice/pages/WorkQueue/components/DraftPreviewModal";
import { FilingLink } from "../../../../stateOffice/pages/FilingBuilder/components";

interface IClosedForCommentTable {
  rows: any;
  columns: any;
  loading: boolean;
}

const ClosedForCommentTable = (props: IClosedForCommentTable) => {
  const {
    // variable
    loading,
    rows,
    columns,
    dataState,
    dataResult,
    dialogOpen,
    proposedRuleData,
    // functions
    toggleDialog,
    dataStateChange,
  } = useClosedForCommentTableController(props);

  const Draft = (data: GridCellProps) => {
    return (
      <td className="newIcon" role="gridcell">
        {data.dataItem.pdf ? (
          <div className="download-links">
            <FilingLink
              fileName={`Proposed-${data.dataItem.rule}_${data.dataItem.commentOpenDate}-${data.dataItem.commentCloseDate}.pdf`}
              guid={data.dataItem.pdf}
              container={"draftpdfs"}
              color="blue"
            />
          </div>
        ) : (
          <div>No Download Available</div>
        )}
      </td>
    );
  };

  return (
    <>
      {proposedRuleData ? (
        <DraftPreviewModal
          open={dialogOpen}
          close={toggleDialog}
          draftData={proposedRuleData}
        />
      ) : null}
      {rows.length > 0 ? (
        <Grid
          data={dataResult}
          sortable
          style={{ minHeight: "70dvh", height: "auto" }}
          pageable
          {...dataState}
          onDataStateChange={dataStateChange}
          filterable
        >
          <GridToolbar>
            <h3>Proposed Rules Closed For Comment</h3>
          </GridToolbar>
          {columns ? (
            columns.map((element: any, i: number) => {
              if (element.hidden != true) {
                if (element.download == true) {
                  return (
                    <GridColumn
                      field={element.field}
                      key={element.title + i}
                      title={element.title}
                      cell={Draft}
                    />
                  );
                } else {
                  return (
                    <GridColumn
                      field={element.field}
                      key={element.title + i}
                      title={element.title}
                    />
                  );
                }
              }
            })
          ) : (
            <CircularProgress />
          )}
        </Grid>
      ) : (
        <GridNoRecords>
          {props.loading ? <CircularProgress /> : "No records found"}
        </GridNoRecords>
      )}
    </>
  );
};

export default ClosedForCommentTable;
